/**
 * Block is used on
 *
 * @returns {{slides: [], activeSlide: null}}
 */
export default () => ({
    slides: [],
    activeSlide: null
})